import { Client } from "@/Common/Api/Client";
import { GuidHelper } from "@/Common/Helpers/GuidHelper";
import { BillableServiceItem } from "@/Common/Models/BillableServiceItem";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BillableServiceDropdownItem } from "@/Patient/Models/UI/BillingHistory/BillableServiceDropdownItem";

import "./BillingServiceAutocomplete.css";

interface IBillingServiceAutocomplete {
    componentId: string;
    selectedItem: BillableServiceDropdownItem;
    selectionOp: number;
    clearOp: number;
    disabled?: boolean;
    focusOnLoad?: boolean;
    closeDropDownAfterSelection?: boolean;
    changedTextValueEvent?: number;
    costCenterId?: string;
    removeServiceOp: number;
}

class BillingServiceAutocompleteState {
    constructor(s?: BillingServiceAutocompleteState) {
        if (s != null) {
            this.q = s.q;
            this.expanded = s.expanded;
            this.infocus = s.infocus;
            this.services = s.services;
        }
        else {
            this.expanded = false;
            this.q = ""; this.services = [];
        }
    }

    public q: string;
    public expanded: boolean;
    public infocus: boolean;
    public services: BillableServiceDropdownItem[];
}

class BillingServiceAutocomplete extends React.Component<IBillingServiceAutocomplete, BillingServiceAutocompleteState> {
    private width: string = "";
    private control: JQuery;
    private debounceMs: number = 350;
    private minQueryLengthSearchChars: number = 2;
    private returnMaxResults: number = 15;
    private timeoutReference: any;

    constructor(props: IBillingServiceAutocomplete) {
        super(props);

        const initialState = new BillingServiceAutocompleteState();
        initialState.infocus = props.focusOnLoad === true;

        this.state = initialState;
        this.blurTimeout = -1;
    }

    public render(): JSX.Element {
        var self = this;

        var dropdownPart = (
            <div style={{ width: this.width }} className="ui-wrp-b">
                <ul data-role="available-options">
                    {this.state.services.map((i: BillableServiceDropdownItem, idx: number) => {
                        var isSelected = self.props.selectedItem == null
                            ? false
                            : (self.props.selectedItem.Service.BillableServiceId === i.Service.BillableServiceId);
                        var css = "";
                        if (isSelected && !i.Active) {
                            css = "selected";
                        }
                        else if (isSelected && i.Active) {
                            css = "selected pending";
                        }
                        else if (!isSelected && i.Active) {
                            css = "pending";
                        }

                        return (
                            <li className={css} key={i.Service.BillableServiceId + "_" + idx} onClick={self.onItemClick.bind(self, i)}>
                                <span>{i.GetServiceName()}</span>
                            </li>
                        );
                    })}
                </ul>
            </div>
        );

        if (!this.state.expanded || this.state.services.length === 0) { dropdownPart = null; }

        return (
            <div id={this.props.componentId} className="billing-service myle-ui-autocomplete" onClick={this.onContainerClick.bind(this)}>

                <div className="ui-wrp-a clearfix">
                    {this.renderSelectedService()}
                    {(this.state.infocus === true || this.props.selectedItem == null) && <input onKeyDown={this.inputKeyDown.bind(this)} onBlur={this.onBlur.bind(this)} onChange={this.searchTextChanged.bind(this)} disabled={this.props.disabled} value={this.state.q} type="text" className="ui-text-input" />}
                    {this.state.infocus === false && this.props.selectedItem != null && <div style={{ height: "3px", clear: "both" }} />}
                </div>
                {dropdownPart}
            </div>
        );
    }

    private renderSelectedService(): JSX.Element {
        if (this.props.selectedItem == null) return null;
        else {
            return (
                <ul className="selected-items-list clearfix">
                    <li onClick={this.stopPropagation.bind(self)}>
                        <span className="content-text">{this.props.selectedItem.Service.NameEn}</span>
                        <span className="remove-btn" onClick={this.removeItem.bind(this)} />
                    </li>
                </ul>
            );
        }
    }

    public componentDidMount(): void {
        this.control = $("#" + this.props.componentId);
        this.width = (this.control.width() + 10) + "px";
        if (this.props.focusOnLoad) {
            $("#" + this.props.componentId).find('input[type="text"]').focus();
        }

        $(window).on("click.services", this.onWindowClick.bind(this));
    }

    public shouldComponentUpdate(nextProps: IBillingServiceAutocomplete, nextState: BillingServiceAutocompleteState): boolean {
        var qs = this.state.q !== nextState.q;
        var selectionChanged = this.props.selectedItem !== nextProps.selectedItem;
        var patientsChanged = this.state.services !== nextState.services;
        var dropdown = this.state.expanded !== nextState.expanded;

        return patientsChanged || selectionChanged || qs || dropdown;
    }

    public componentWillUnmount(): void {
        $(window).off("click.services");
    }

    private stopPropagation(e: React.MouseEvent): void {
        e.stopPropagation();
    }

    private onContainerClick(e: React.MouseEvent): void {
        e.stopPropagation();
        this.stopBlurEvent();
        var self = this;
        var s = new BillingServiceAutocompleteState(this.state);
        s.expanded = true;
        s.infocus = true;
        this.setState(s);

        window.setTimeout(
            () => {
                var tb = $("#" + self.props.componentId).find('input[type="text"]');
                var val = tb.val();
                tb.val("");
                tb.focus();
                tb.val(val);
            },
            50
        );
    }

    private onWindowClick(): void {
        var s = new BillingServiceAutocompleteState(this.state);
        s.expanded = false;
        if (this.props.selectedItem != null) { s.infocus = false; }
        this.setState(s); // render with dropdown
    }

    private inputKeyDown(e: React.KeyboardEvent): void {
        if (e.keyCode === 8) {
            // delete last item
            if (e.ctrlKey) {
                if (this.state.q.length === 0) {
                    var operation = new LocalEvent(this.props.clearOp);
                    LocalEventDispatcher.dispatch(operation);
                }
            }
            else {
                if (this.props.selectedItem != null && this.state.q.length === 0) {
                    // send remove service operation from selected services
                }
            }
        }

        // up
        if (e.keyCode === 38) { e.preventDefault(); this.previousItem(); }

        // down
        if (e.keyCode === 40) { e.preventDefault(); this.nextItem(); }

        // enter
        if (e.keyCode === 13) { this.stopBlurEvent(); this.addSeletedItem(); }

        // escape
        if (e.keyCode === 27) {
            this.clearState();
        }
    }

    private stopBlurEvent(): void {
        clearTimeout(this.blurTimeout);
        this.blurTimeout = -1;
    }

    // keyboard triggered
    private nextItem(): void {
        var collection = this.state.services;
        var idx = this.indexOfSelectedItem();
        if (idx === -1) {
            collection[0].Active = true;
            this.updateStateWithNewPatientList(collection, true);
            return;
        }
        if (idx + 1 < collection.length) {
            collection[idx].Active = false;
            collection[idx + 1].Active = true;
            this.updateStateWithNewPatientList(collection, true);
        }
        this.scrollDown();
    }

    private scrollUp(): void {
        var container = $("#" + this.props.componentId);
        var scrollContainer = container.find("div.ui-wrp-b");
        var ul = container.find('ul[data-role="available-options"]');
        var numberOfItems = ul.find("li").length;
        var h = ul.height();
        var sct = scrollContainer.scrollTop();
        var scrollBy = h / numberOfItems;
        if (scrollBy > 1) { scrollContainer.scrollTop(sct - scrollBy); }
    }

    private scrollDown(): void {
        var container = $("#" + this.props.componentId);
        var scrollContainer = container.find("div.ui-wrp-b");
        var ul = container.find('ul[data-role="available-options"]');
        var numberOfItems = ul.find("li").length;
        var h = ul.height();
        var sct = scrollContainer.scrollTop();
        var scrollBy = h / numberOfItems;
        if (scrollBy > 1) { scrollContainer.scrollTop(sct + scrollBy); }
    }

    // keyboard triggered
    private previousItem(): void {
        var idx = this.indexOfSelectedItem();
        if (idx === -1) {
            this.collapseDropdown();
            return;
        }

        var collection = this.state.services;
        if (idx === 0) {
            collection[0].Active = false;
            this.updateStateWithNewPatientList(collection, false);
            return;
        }

        if (idx > 0) {
            collection[idx].Active = false;
            idx--;
            collection[idx].Active = true;
            this.updateStateWithNewPatientList(collection, true);
        }

        else if (idx === 1) {
            collection[0].Active = true;
            collection[1].Active = false;
            this.updateStateWithNewPatientList(collection, false);
        }

        this.scrollUp();
    }

    // keyboard triggered
    private addSeletedItem(): void {
        var idx = this.indexOfSelectedItem();
        if (idx >= 0) {
            var operation = new LocalEvent(this.props.selectionOp);
            this.state.services[idx].Service.IsFromServiceList = true;
            operation.AddItem("value", this.state.services[idx]);
            operation.AddItem("id", this.props.componentId);
            LocalEventDispatcher.dispatch(operation);
            this.clearQuestyString();

            if (this.props.closeDropDownAfterSelection) { this.clearState(); }
        }
    }

    private onItemClick(item: BillableServiceDropdownItem, e: React.MouseEvent<HTMLLIElement>): void {
        this.stopBlurEvent();
        e.stopPropagation();
        var operation = new LocalEvent(this.props.selectionOp);
        item.Service.IsFromServiceList = true;
        operation.AddItem("value", item);
        operation.AddItem("id", this.props.componentId);
        LocalEventDispatcher.dispatch(operation);
        this.clearQuestyString();

        if (this.props.closeDropDownAfterSelection) { this.clearState(); }
    }

    private updateStateWithNewPatientList(list: BillableServiceDropdownItem[], expand: boolean): void {
        var state = new BillingServiceAutocompleteState(this.state);
        state.expanded = expand;
        state.services = list.map(i => i);
        this.setState(state);
    }

    // returns index of item in state.services array of active item
    private indexOfSelectedItem(): number { if (this.state.services.length === 0) return -1; for (var i = 0; i < this.state.services.length; i++) { if (this.state.services[i].Active) { return i; } } return -1; }

    private removeItem(e: React.MouseEvent<HTMLSpanElement>): void {
        e.stopPropagation();
        const operation = new LocalEvent(this.props.clearOp);
        operation.AddItem("value", this.props.selectedItem);
        operation.AddItem("id", this.props.componentId);
        this.clearQuestyString();

        LocalEventDispatcher.dispatch(operation);

        this.removeService();
    }

    private removeService(): void {
        const operation = new LocalEvent(this.props.removeServiceOp);
        operation.AddItem("id", this.props.componentId);
        LocalEventDispatcher.dispatch(operation);
    }

    private searchTextChanged(e: React.ChangeEvent<HTMLInputElement>): void {
        if (this.timeoutReference != null) {
            clearTimeout(this.timeoutReference);
            this.timeoutReference = null;
        }

        var q = e.target.value;
        var state = new BillingServiceAutocompleteState(this.state);
        state.q = q;
        this.setState(state);

        if (this.props.changedTextValueEvent) {
            var operation = new LocalEvent(this.props.changedTextValueEvent);
            operation.AddItem("value", q);
            LocalEventDispatcher.dispatch(operation);
        }

        var self = this;
        this.timeoutReference = window.setTimeout(
            () => self.invokeDebouncedSearch(q),
            self.debounceMs
        );
    }

    private invokeDebouncedSearch(q: string): void {
        if (q == null) return;
        var self = this;
        if (q.length < this.minQueryLengthSearchChars) return;
        var data = { Query: q, IsInactive: false, ResultsToReturn: self.returnMaxResults, CostCenterId: this.props.costCenterId };
        var client = new Client();
        client.Post(apiSettings.buildApiPath(), ServerOperations.Server.Myle_Patient_History_GetBillableService, data, this.onResponseReceived.bind(this), e => console.log(e));
    }

    private onResponseReceived(response: { BillableService: BillableServiceItem[] }): void {
        var results: BillableServiceItem[] = response.BillableService;
        if (results == null) return;
        var collection = results.map((p: BillableServiceItem) => {
            var service = new BillableServiceDropdownItem();
            service.Service = p;
            service.Active = false;
            return service;
        });

        var state = new BillingServiceAutocompleteState(this.state);
        state.expanded = true;
        state.services = collection;
        this.setState(state);
    }

    private collapseDropdown(): void {
        this.changeDropdown(false);
    }

    private changeDropdown(expand: boolean): void {
        var state = new BillingServiceAutocompleteState(); state.expanded = expand; state.infocus = this.state.infocus; state.services = this.state.services; state.q = this.state.q; this.setState(state);
    }

    private clearState(): void {
        var state = new BillingServiceAutocompleteState();
        state.expanded = false;
        state.infocus = false;
        state.services = [];
        state.q = ""; this.setState(state);
    }

    private clearQuestyString(): void {
        var state = new BillingServiceAutocompleteState(this.state);
        state.q = "";
        this.setState(state);
    }

    private blurTimeout: number;
    private onBlur(e: React.FocusEvent<HTMLInputElement>): void {
        var self = this;
        var val = e.target.value;

        this.blurTimeout = window.setTimeout(() => {
            self.completeBlurEvent(val);
        }, 300);
    }

    private completeBlurEvent(val: string): void {
        var self = this;
        if (val != null && val != "") {
            var item = new BillableServiceDropdownItem();

            item.Active = true;
            item.Service = new BillableServiceItem();
            item.Service.BillableServiceId = GuidHelper.Empty();
            item.Service.NameEn = val;
            item.Service.NameFr = val;
            item.Service.NameEs = val;
            item.Service.HasGST = false;
            item.Service.HasQST = false;
            item.Service.Number = "";
            item.Service.Price = 0;
            item.Service.IsFromServiceList = false;

            // find empty guid entry and remove it if exist

            var s = new BillingServiceAutocompleteState(this.state);
            s.expanded = false;
            s.infocus = false;
            s.q = "";
            var idx = -1;
            for (var i = 0; i < s.services.length; i++) {
                if (s.services[i].Service.BillableServiceId === GuidHelper.Empty()) {
                    idx = i;
                    break;
                }
            }
            if (idx >= 0) { s.services.splice(idx, 1); }

            s.services.push(item);
            this.setState(s);

            window.setTimeout(() => {
                var operation = new LocalEvent(self.props.selectionOp);
                operation.AddItem("value", item);
                operation.AddItem("id", self.props.componentId);
                LocalEventDispatcher.dispatch(operation);
                self.clearQuestyString();
            }, 50);
        }
    }
}

export { BillingServiceAutocomplete };
